import { CoreIcon } from '../core-icon';
import coinCircleSVG from '../../assets/icons/coin-circle.svg';
import type { IconProps } from '../core-icon';

export const CoinCircleIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={coinCircleSVG} {...props} />;
};
